
export const REQUEST_FORM_SEND = "requestForm/REQUEST_FORM_SEND";
export const REQUEST_FORM_SUCCESS = "requestForm/REQUEST_FORM_SUCCESS";
export const REQUEST_FORM_FAILED = "requestForm/REQUEST_FORM_FAILED";
export const REQUEST_FORM_RESET = "requestForm/REQUEST_FORM_RESET";
export const LOADING_POST_FILE_UPLOAD = "requestForm/LOADING_POST_FILE_UPLOAD";
export const POST_FILE_UPLOAD = "requestForm/POST_FILE_UPLOAD";
export const DELETE_FILE_UPLOAD = "requestForm/DELETE_FILE_UPLOAD";
export const POST_PRODUCT_FC_RENDA = "requestForm/POST_PRODUCT_FC_RENDA";